import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@46.0.0_@parcel+watcher@2.5.1_@types+node@22.14.1_@unhead+vue@2.0.5_vue@_9de09c922fe996fe2bd32eced12ef30c/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}